/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SignupType = {
    Email: 'EMAIL',
    Google: 'GOOGLE',
    Sso: 'SSO',
    Punchout: 'PUNCHOUT'
} as const;
export type SignupType = typeof SignupType[keyof typeof SignupType];


export function instanceOfSignupType(value: any): boolean {
    for (const key in SignupType) {
        if (Object.prototype.hasOwnProperty.call(SignupType, key)) {
            // @ts-ignore
            if (SignupType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SignupTypeFromJSON(json: any): SignupType {
    return SignupTypeFromJSONTyped(json, false);
}

export function SignupTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupType {
    return json as SignupType;
}

export function SignupTypeToJSON(value?: SignupType | null): any {
    return value as any;
}

